import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const InitialConditionSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.initial_condition_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.POSITION}`)}
          name={`MCS.${FORM_NAME.MCS.POSITION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.POSITION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.POSITION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.POSITION}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.POSITION}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.POSITION}`) }),
          }}
          unit="x, y, z) (m"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.VELOCITY}`)}
          name={`MCS.${FORM_NAME.MCS.VELOCITY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.VELOCITY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.VELOCITY}`) }),
          }}
          unit="x, y, z) (m/s"
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`)}
          name={`MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ATTITUDE_ANGLE]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.ATTITUDE_ANGLE}`) }),
          }}
          unit="x, y, z) (deg"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`)}
          name={`MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ANGULAR_VELOCITY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.ANGULAR_VELOCITY}`) }),
          }}
          unit="x, y, z) (deg/s"
        />
      </div>
    </div>
  );
};

export default InitialConditionSigma;
